/* ============================================================
   DOORMAT.COM THEME — theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     UTILITIES
  ---------------------------------------------------------- */
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function showToast(message, type = '') {
    let toast = document.getElementById('site-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'site-toast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.className = 'toast' + (type ? ' toast--' + type : '');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => { toast.classList.add('show'); });
    });
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => { toast.classList.remove('show'); }, 3000);
  }

  /* ----------------------------------------------------------
     MOBILE MENU DRAWER
  ---------------------------------------------------------- */
  const menuToggle = document.getElementById('menu-toggle');
  const menuDrawer = document.getElementById('menu-drawer');
  const menuOverlay = document.getElementById('menu-drawer-overlay');
  const menuClose  = document.getElementById('menu-drawer-close');

  function openMenu() {
    menuDrawer.classList.add('open');
    menuOverlay.classList.add('open');
    menuOverlay.setAttribute('aria-hidden', 'false');
    menuDrawer.setAttribute('aria-modal', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menuDrawer.classList.remove('open');
    menuOverlay.classList.remove('open');
    menuOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose)  menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  // Submenu toggles inside mobile menu
  document.querySelectorAll('.menu-drawer__link--parent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const submenu = this.nextElementSibling;
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isOpen);
      submenu.classList.toggle('open', !isOpen);
    });
  });

  /* ----------------------------------------------------------
     SEARCH BAR TOGGLE
  ---------------------------------------------------------- */
  const searchToggle  = document.getElementById('search-toggle');
  const headerSearch  = document.getElementById('header-search');
  const searchClose   = document.getElementById('search-close');

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      const isOpen = headerSearch.classList.toggle('open');
      if (isOpen) {
        const input = headerSearch.querySelector('input');
        if (input) setTimeout(() => input.focus(), 50);
      }
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      headerSearch.classList.remove('open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (headerSearch && headerSearch.classList.contains('open')) headerSearch.classList.remove('open');
      if (cartDrawer && cartDrawer.classList.contains('open')) closeCart();
      if (menuDrawer && menuDrawer.classList.contains('open')) closeMenu();
    }
  });

  /* ----------------------------------------------------------
     CART DRAWER
  ---------------------------------------------------------- */
  const cartDrawer    = document.getElementById('cart-drawer');
  const cartOverlay   = document.getElementById('cart-drawer-overlay');
  const cartClose     = document.getElementById('cart-drawer-close');

  function openCart() {
    fetchCart().then(renderCartDrawer);
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    cartOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    cartOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });

  /* Fetch cart from Shopify AJAX API */
  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function renderCartDrawer(cart) {
    const content   = document.getElementById('cart-drawer-content');
    const subtotal  = document.getElementById('cart-drawer-subtotal');
    const checkout  = document.getElementById('cart-drawer-checkout');

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    // Update all cart counts in header
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });

    if (!cart.item_count) {
      content.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path d="M6 6h4l5.5 27h21l4-16H14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="20" cy="38" r="2.5" fill="currentColor"/>
            <circle cx="34" cy="38" r="2.5" fill="currentColor"/>
          </svg>
          <p>Your cart is empty.</p>
          <a href="/collections/all">Start shopping →</a>
        </div>`;
      if (checkout) checkout.style.display = 'none';
      return;
    }

    if (checkout) checkout.style.display = '';
    content.innerHTML = cart.items.map(function (item) {
      const props = Object.entries(item.properties || {})
        .filter(([k, v]) => v && !k.startsWith('_'))
        .map(([k, v]) => `<div>${k}: <strong>${v}</strong></div>`).join('');
      return `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__image"
            src="${item.image ? item.image.replace(/(\.[a-z]+)$/, '_100x100$1') : ''}"
            alt="${item.title}" loading="lazy">
          <div class="cart-item__details">
            <div class="cart-item__title">${item.product_title}</div>
            ${item.variant_title ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
            ${props ? `<div class="cart-item__props">${props}</div>` : ''}
            <div class="cart-item__row">
              <div class="cart-item__qty">
                <button class="cart-qty-btn" data-key="${item.key}" data-delta="-1" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button class="cart-qty-btn" data-key="${item.key}" data-delta="1" aria-label="Increase quantity">+</button>
              </div>
              <div class="cart-item__price">${formatMoney(item.line_price)}</div>
            </div>
          </div>
        </div>`;
    }).join('');

    // Bind qty buttons
    content.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key     = this.dataset.key;
        const delta   = parseInt(this.dataset.delta, 10);
        const item    = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty  = Math.max(0, item.quantity + delta);
        updateCartItem(key, newQty);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(r => r.json()).then(renderCartDrawer);
  }

  /* ----------------------------------------------------------
     ADD TO CART (product form)
  ---------------------------------------------------------- */
  const productForm = document.getElementById('product-form');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Validate required personalization fields
      let valid = true;
      this.querySelectorAll('[required]').forEach(function (field) {
        if (!field.value.trim()) {
          field.style.borderColor = 'var(--color-error)';
          valid = false;
        } else {
          field.style.borderColor = '';
        }
      });

      const errorEl = this.querySelector('.product-form__error');
      if (!valid) {
        if (errorEl) { errorEl.textContent = 'Please fill in all required fields above.'; errorEl.classList.add('show'); }
        return;
      }
      if (errorEl) errorEl.classList.remove('show');

      const btn = this.querySelector('[type=submit]');
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span class="spinner"></span>';
      btn.disabled = true;

      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(r => {
          if (!r.ok) return r.json().then(d => Promise.reject(d));
          return r.json();
        })
        .then(function () {
          showToast('Added to cart!', 'success');
          openCart();
        })
        .catch(function (err) {
          const msg = err && err.description ? err.description : 'Something went wrong. Please try again.';
          if (errorEl) { errorEl.textContent = msg; errorEl.classList.add('show'); }
          showToast(msg, 'error');
        })
        .finally(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
        });
    });
  }

  /* ----------------------------------------------------------
     PRODUCT GALLERY — thumbnail switcher
  ---------------------------------------------------------- */
  const mainImage  = document.getElementById('product-main-image');
  const thumbWrap  = document.querySelector('.product-gallery__thumbs');

  if (mainImage && thumbWrap) {
    thumbWrap.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const src     = this.dataset.src;
        const srcset  = this.dataset.srcset || '';
        thumbWrap.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
      });
    });
  }

  /* ----------------------------------------------------------
     VARIANT SELECTOR — update price on change
  ---------------------------------------------------------- */
  const variantSelect = document.getElementById('variant-select');
  if (variantSelect && window.productVariants) {
    variantSelect.addEventListener('change', function () {
      const variantId = parseInt(this.value, 10);
      const variant   = window.productVariants.find(v => v.id === variantId);
      if (!variant) return;

      // Update price display
      const priceEl   = document.getElementById('product-price');
      const compareEl = document.getElementById('product-price-compare');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Update availability
      const addBtn = document.getElementById('add-to-cart-btn');
      if (addBtn) {
        if (!variant.available) {
          addBtn.textContent = 'Sold Out';
          addBtn.disabled = true;
        } else {
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
        }
      }
    });
  }

  /* ----------------------------------------------------------
     QUANTITY STEPPER (product page)
  ---------------------------------------------------------- */
  const qtyInput   = document.getElementById('quantity-input');
  const qtyInc     = document.getElementById('qty-increase');
  const qtyDec     = document.getElementById('qty-decrease');

  if (qtyInput) {
    if (qtyInc) qtyInc.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
    if (qtyDec) qtyDec.addEventListener('click', function () {
      const val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyInput.addEventListener('input', function () {
      const val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
    });
  }

  /* ----------------------------------------------------------
     ACCORDION
  ---------------------------------------------------------- */
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const item = this.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.accordion-item.open').forEach(i => i.classList.remove('open'));
      // Open clicked if it was closed
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ----------------------------------------------------------
     CART PAGE — remove / update quantities
  ---------------------------------------------------------- */
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = this.dataset.cartRemove;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(() => window.location.reload());
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      const key = this.dataset.cartQty;
      const qty = parseInt(this.value, 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(() => window.location.reload());
    });
  });

  /* ----------------------------------------------------------
     SORT / FILTER — collection page
  ---------------------------------------------------------- */
  const sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

})();
